import { Instagram, Twitter, Facebook, Youtube, Mail } from "lucide-react";

const LINKS = {
  Read: [
    { label: "Cover Story", href: "#cover" },
    { label: "Regular Sections", href: "#sections" },
    { label: "Signature Features", href: "#features" },
    { label: "Quarterly Themes", href: "#themes" },
  ],
  Engage: [
    { label: "Submit a Letter", href: "#subscribe" },
    { label: "Write for Listen", href: "mailto:editors@listenmag.africa" },
    { label: "Community Heroes", href: "#sections" },
    { label: "Youth Voices", href: "#sections" },
  ],
  Business: [
    { label: "Advertise", href: "#partners" },
    { label: "Sponsor an Issue", href: "#partners" },
    { label: "Distribution Partners", href: "mailto:distro@listenmag.africa" },
    { label: "Press", href: "mailto:press@listenmag.africa" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative bg-[#2E1A6B] text-white grain overflow-hidden">
      <div className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 pt-16 md:pt-24 pb-10">
        {/* Massive wordmark */}
        <div className="border-b border-white/15 pb-8 md:pb-12 mb-12 md:mb-16">
          <div className="font-display font-black tracking-tighter leading-[0.85] text-[22vw] md:text-[18vw] lg:text-[220px] text-white select-none">
            <span className="italic text-[#2AC1E0]">li</span>sten
          </div>
          <div className="mt-2 text-xs md:text-sm uppercase tracking-[0.35em] font-semibold text-white/70">
            The Voice of the Adolescent
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4 flex flex-col gap-6">
            <p className="text-sm text-white/70 leading-relaxed max-w-sm">
              Listen Magazine is published quarterly in Accra, Ghana, with a pan-African digital
              edition. Educate. Inspire. Empower. Celebrate.
            </p>
            <div className="flex items-center gap-3">
              {[Instagram, Twitter, Facebook, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`social-${i}`}
                  className="h-10 w-10 border border-white/25 flex items-center justify-center hover:bg-[#2AC1E0] hover:text-[#2E1A6B] hover:border-[#2AC1E0] transition-colors"
                  aria-label="Social link"
                >
                  <Icon size={16} />
                </a>
              ))}
            </div>
            <a
              href="mailto:hello@listenmag.africa"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-sm text-[#2AC1E0] hover:text-white transition-colors"
            >
              <Mail size={16} /> hello@listenmag.africa
            </a>
          </div>

          {Object.entries(LINKS).map(([group, items]) => (
            <div key={group} className="md:col-span-2 lg:col-span-2">
              <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#2AC1E0] mb-4">
                {group}
              </div>
              <ul className="space-y-3">
                {items.map((it) => (
                  <li key={it.label}>
                    <a
                      href={it.href}
                      data-testid={`footer-link-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-white/80 hover:text-[#2AC1E0] transition-colors"
                    >
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#2AC1E0] mb-4">
              Office
            </div>
            <address className="not-italic text-sm text-white/80 leading-relaxed">
              Accra, Ghana<br />
              West Africa
            </address>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-white/50">
          <div>© {new Date().getFullYear()} Listen Magazine. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" data-testid="footer-privacy" className="hover:text-white">Privacy</a>
            <a href="#" data-testid="footer-terms" className="hover:text-white">Terms</a>
            <a href="#" data-testid="footer-imprint" className="hover:text-white">Imprint</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
